import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import type { IFileResponse } from "@/interfaces";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  object
>("courses.accessCodes.exportQrCodes");

export const exportQrCodes = {
  ...postApis,
};
